<script>
import { imgHost2 } from "@/config/index";


export default {
  props: {
    planData: {
      type: Array | Object,
      default: () => []
    }
  },
  data () {
    return {
      imgHost2
    };
  }
}
</script>

<template>
  <div v-if="planData" class="care-program">
    <div class="care-program-header btlr">
      常见疾病
    </div>
    <div class="care-program-header">
      保健品方案
    </div>
    <div class="care-program-header btrr">
      安全注意事项
    </div>
    <div class="care-program-content">
      {{ planData[0].ne }}
    </div>
    <div class="care-program-content">
      {{ planData[0].plan }}
    </div>
    <div class="care-program-content">
      {{ planData[0].precautions }}
    </div>

    <div class="care-program-content">
      {{ planData[1].ne }}
    </div>
    <div class="care-program-content">
      {{ planData[1].plan }}
    </div>
    <div class="care-program-content">
      {{ planData[1].precautions }}
    </div>

    <div class="care-program-content bblr">
      {{ planData[2].ne }}
    </div>
    <div class="care-program-content">
      {{ planData[2].plan }}
    </div>
    <div class="care-program-content bbrr">
      {{ planData[2].precautions }}
    </div>
  </div>
  <div v-else>
    暂无数据
  </div>
</template>

<style lang="scss" scoped>
$borderRadius: 8px;

$activeBorderColor: #6580f8;

.care-program {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-template-rows: auto 1fr 1fr 1fr;

  >div {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 2px;
    background-color: #ebefff;

    &:nth-child(3n + 2) {
      border-right: 2px solid $activeBorderColor;
      border-left: 2px solid $activeBorderColor;
    }

    &:nth-child(n) {
      border-bottom: 1px solid #bfcdff;
    }

    &:nth-child(n + 10) {
      border-bottom: none;
    }

    &:nth-child(2) {
      border-top: 2px solid $activeBorderColor;
      border-top-left-radius: $borderRadius;
      border-top-right-radius: $borderRadius;
      overflow: hidden;
    }

    &:nth-last-child(2) {
      border-bottom: 4px solid $activeBorderColor;
      border-bottom-left-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
      overflow: hidden;
    }
  }

  &-step {
    padding-right: 10px;

    &-pic {
      position: relative;
      height: 100%;
      min-width: 60px;
    }
  }
}

.btlr {
  border-top-left-radius: $borderRadius;
}

.btrr {
  border-top-right-radius: $borderRadius;
}

.bblr {
  border-bottom-left-radius: $borderRadius;
}

.bbrr {
  border-bottom-right-radius: $borderRadius;
}
</style>
